import WidgetModule from "@eisinc/Overrides/Widgets/Header/HeaderSearchInput";

export * from "@eisinc/Overrides/Widgets/Header/HeaderSearchInput";

export default WidgetModule;
